import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import PublicationEditionHeader from '@components/PublicationEditionHeader'

import usePublicationEdition from '@hooks/usePublicationEdition'

import BrandGroupGroup from './BrandGroupGroup'

interface PublicationEditionGroupProps {
  editionBrandGroups: object,
  orderCount: number,
  publicationEditionId: number,
}

const PublicationEditionGroup = (props: PublicationEditionGroupProps) => {
  const { editionBrandGroups, orderCount, publicationEditionId } = props

  const { publication, publicationEdition } = usePublicationEdition({ id: publicationEditionId })

  const secondaryText = orderCount === 1 ? '1 Booking' : `${orderCount} Bookings`

  const inspectionDeadline = digObject(publicationEdition, 'dates.booking.date_time', '')
  const formattedDeadline = formatDate(inspectionDeadline, 'dd/MM/yyyy HH:mm', "ccc dd LLL y 'at' h:mma")

  return (
    <DashboardModule
      customHeader={(
        <PublicationEditionHeader
          publicationEdition={publicationEdition}
          // @ts-expect-error TS2339
          publicationTitle={publication.title}
        >
          <Text color="faintGrey" fontSize="small" marginBottom="small">
            {secondaryText}
          </Text>

          <PublicationEditionHeader.Deadline deadline={formattedDeadline} />
        </PublicationEditionHeader>
      )}
    >
      <Box flexDirection="column">
        {Object.values(editionBrandGroups).map((editionBrandGroup, i, arr) => (
          <BrandGroupGroup
            editionBrandGroup={editionBrandGroup}
            isLastGroup={arr.length - 1 === i}
            key={editionBrandGroup.id}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default PublicationEditionGroup
